// src/lib/sheetNumbering.js
// ───────────────────────────────────────────────────────────────────────────
// Numeración ATÓMICA del correlativo de planchas (fix: correlativo no salta).
//
// Invariante: el número del correlativo se reserva SOLO después de confirmar la subida
// del archivo de diseño, y SIEMPRE dentro de una transacción sobre el doc contador (para
// que dos guardados simultáneos tomen números DISTINTOS, sin colisión ni salto).
//
// Funciones puras/inyectables (db + fns de firestore se pasan) → unit-testeables sin React.
// ───────────────────────────────────────────────────────────────────────────

/**
 * ¿Están confirmadas las subidas de los archivos seleccionados? Si se eligió un archivo de
 * diseño (front/back) pero su info de subida aún no está, la subida NO está confirmada y la
 * reserva del número NO debe proceder (si no, un upload fallido/cancelado quema un número).
 * @returns {boolean}
 */
export function uploadsConfirmed({ designFileFront, uploadedFileFrontInfo, designFileBack, uploadedFileBackInfo } = {}) {
  if (designFileFront && !uploadedFileFrontInfo) return false;
  if (designFileBack && !uploadedFileBackInfo) return false;
  return true;
}

/**
 * Reserva ATÓMICA del número de plancha vía runTransaction sobre el doc contador.
 * Número gap-free y monótono: assigned = max(existingMax, contador.count) + 1, leído y
 * escrito DENTRO de la transacción → dos guardados concurrentes serializan en el contador
 * y obtienen números distintos.
 * @param {object} args
 * @param {*} args.db
 * @param {string} args.jobId
 * @param {string} args.key       clave de numeración (bloque/componente)
 * @param {string} args.block
 * @param {number} args.existingMax  máximo sheetNumber ya existente (gap-free)
 * @param {{ doc:Function, runTransaction:Function }} args.fb  fns de firestore (inyectables)
 * @returns {Promise<number>}  número reservado
 */
export async function reserveSheetNumberAtomic({ db, jobId, key, block, existingMax, fb }) {
  const { doc, runTransaction } = fb;
  const counterRef = doc(db, `jobs/${jobId}/sheetCounters`, key);
  return runTransaction(db, async (tx) => {
    const snap = await tx.get(counterRef);
    const prev = snap.exists && snap.exists() ? (Number(snap.data().count) || 0) : 0;
    const assigned = Math.max(Number(existingMax) || 0, prev) + 1;
    tx.set(counterRef, { count: assigned, block, updatedAt: new Date() }, { merge: true });
    return assigned;
  });
}
